module.exports = __webpack_public_path__ + "4fca0e60a1cfc1c71961e92b1def2da9.png";